<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('/img/CrowdifyDashboardDesk.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">For Users.</h1>
        </div>
      </div>
    </div>

    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title">Crowdify Dashboard</h2>

            <h3>Settings</h3>
            <div class="container">
              <div class="row">
                <div class="col-md">
                  <img style="max-height:35px; text-align:center" src="/img/dashboard_settings_steps_1.png">
                </div>
                <div class="col-md">
                  <img style="max-height:35px; text-align:center" src="/img/dashboard_settings_steps_2.png">
                </div>
                <div class="col-md">
                  <img style="max-height:35px; text-align:center" src="/img/dashboard_settings_steps_3.png">
                </div>
              </div>
              <div class="row d-none d-lg-block">
                <img style="text-align:center" src="/img/dashboard_settings.png">
              </div>
            </div>

            <div style="padding-top:40px"/>

            <h3>Legend</h3>
              <div class="row">
                <div class="col-sm-4" style="background-color:#FFFFFF; color:black">
                  <h5>
                    Event Card
                  </h5>
                  <span>Important information in one place</span>
                </div>
                <div class="col-sm-8" style="display:flex; background-color:#FFFFFF; justify-content:center; align-items:center;">
                  <img style="max-height:200px; text-align:center" src="/img/eventcard_legend_regular.png">
                </div>
              </div>


              <div class="row">
                <div class="col-sm-4" style="background-color:#FFFFFF; color:black">
                  <h4>Clustering</h4>
                  <span>If there are multiple events in a certain region we are going to cluster them</span>
                </div>
                <div class="col-sm-8" style="display:flex; background-color:#FFFFFF; justify-content:center; align-items:center;">
                  <video style="max-height:300px" autoplay="" loop="" muted="" playsinline="" src="/video/legend_screencast.mp4" class="ax ay az ba bs ce">Ihr Browser unterstützt kein HTML5-Video.</video>
                </div>
              </div>

              <DocumentationFooter/>

          </div>



          </div> <!-- end:col bootstrap -->
        </div> <!-- end:row -->
      </div> <!-- end:container section -->
    </div> <!-- end:about us -->






</template>
<script>
import DocumentationFooter from './components/DocumentationFooter';

import { Auth } from 'aws-amplify'

import { Button } from '@/components';
export default {
  name: 'Landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    DocumentationFooter
  },
  data() {
    return {
    };
  }
};
</script>
<style>

.metadata {
    font-size: 1.2em;
    font-weight: 700;
    margin-bottom: 15px;
}



</style>
